export default __webpack_public_path__ + "static/media/112.5e1c9309.jpg";